import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { SchedulePage } from './pages/SchedulePage';
import { AdminPage } from './pages/AdminPage';
import { ContactsPage } from './pages/ContactsPage';
import { ChoirPage } from './pages/ChoirPage';
import { ChoirAdminPage } from './pages/ChoirAdminPage';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/music" element={<SchedulePage />} />
        <Route path="/music/admin" element={<AdminPage />} />
        <Route path="/music/contacts" element={<ContactsPage />} />
        <Route path="/choir" element={<ChoirPage />} />
        <Route path="/choir/admin" element={<ChoirAdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}
